import { UsageOverview } from "./types";

export const transformUsageOverview = (res: any): UsageOverview => ({
  subscription: res.subscription
    ? {
        packs: res.subscription.packs ?? [],
        billingPeriod: res.subscription.billingPeriod ?? "",
        status: res.subscription.status ?? "",
        trialEndsOn: res.subscription.trialEndsOn ?? null,
        vehicleCount: res.subscription.vehicleCount ?? 0,
        monthAmount: res.subscription.monthAmount ?? null,
        isMinimumApplied: res.subscription.isMinimumApplied ?? false,
      }
    : null,
  usageSince: res.usageSince,
  usage: (res.usage ?? []).map((u: any) => ({
    keyCode: u.keyCode,
    name: u.name ?? u.keyCode,
    count: u.count ?? 0,
    amount: u.amount ?? 0,
  })),
  usageTotal: res.usageTotal ?? 0,
});
